module.exports = __webpack_public_path__ + "img/cinematography.fb9ea13a.png";